import * as React from 'react';
import { bem, classnames } from '../../lib';
import { HeaderStart } from './HeaderStart';
import { HeaderMiddle } from './HeaderMiddle';
import { HeaderEnd } from './HeaderEnd';
/**
 * Header component
 *
 * @visibleName Header
 */
let Header = /** @class */ (() => {
    class Header extends React.Component {
        render() {
            const { children, className } = this.props;
            return (React.createElement("div", { className: classnames(className, bem('header')) }, children));
        }
    }
    Header.Start = HeaderStart;
    Header.Middle = HeaderMiddle;
    Header.End = HeaderEnd;
    return Header;
})();
export { Header };
//# sourceMappingURL=Header.js.map